import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';

@Component({
  selector: 'app-password-manager',
  templateUrl: './password-manager.component.html',
  styleUrls: ['./password-manager.component.css'],
})
export class PasswordManagerComponent {
  passwordManagerForm!: FormGroup;
  resetPasswordForm = false;
  showPassword = false;
  newPassword = false;
  reEnterPassword = false;
  constructor(
    private formBuilder: FormBuilder,
    private UserServices: UserService,
    private toastrMsgService: ToastrMsgService
  ) {}
  ngOnInit() {

    const userData = JSON.parse(localStorage.getItem('user') ||'{}');
    
    this.passwordManagerForm = this.formBuilder.group(
      {
        email:[userData.user?.email],
        old_password: ['', Validators.required],
        new_password: ['', Validators.required],
        reEnterPassword: ['', Validators.required],
      },
      {
        validator: this.confirmPasswordValidator(
          'new_password',
          'reEnterPassword'
        ),
      }
    );
  }
  confirmPasswordValidator(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (
        matchingControl.errors &&
        !matchingControl.errors['confirmPasswordValidator']
      ) {
        // return if another validator has already found an error on the matchingControl
        return;
      }

      // set error on matchingControl if validation fails
      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ confirmPasswordValidator: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }
  addPassword(value: any) {
    if (this.passwordManagerForm.valid) {
      const submissionData = {
        email:this.passwordManagerForm.value.email,
        currentPassword: this.passwordManagerForm.value.old_password,
        newPassword: this.passwordManagerForm.value.new_password,
      };

      this.UserServices.updatePassword(submissionData).subscribe({
        next: (response) => {
          this.toastrMsgService.success(response.data);
          if (response?.success) {
            this.UserServices.logout();
          }
          this.ngOnInit();
        },
        error: (error) => {
          this.toastrMsgService.error(error.error.errorMessage);
        },
        complete: () => {
          console.log('Get request completed');
          // clean-up logic for this
        },
      });
    }
  }
}
